import { updateService } from "../HttpService";

export const updateBusDriver = (id, formData) => {
  return updateService(`busDrivers/${id}`, {}, formData);
};
